import { render, staticRenderFns } from "./coverage.vue?vue&type=template&id=6ba06a3e&"
import script from "./coverage.vue?vue&type=script&lang=js&"
export * from "./coverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports